module.exports = __webpack_public_path__ + "media/images/modal-close-b@2x-5fad103e1549c2777f47e925ab78bb95.png";